import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import libraryService from '../../services/libraryService';
import { BookOpen, Money } from '@phosphor-icons/react';

function MyLoansPanel() {
  const [loans, setLoans] = useState([]);
  const [fines, setFines] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const [loansData, finesData] = await Promise.all([
          libraryService.getMyLoans(),
          libraryService.getFines({ mine: true, status: 'pending' }),
        ]);
        setLoans(loansData || []);
        setFines(finesData.items || []);
      } catch (error) {
        toast.error(error.message || 'Unable to load your loans');
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const activeLoans = loans.filter((l) => l.status === 'active');

  if (loading) return null;
  if (activeLoans.length === 0 && fines.length === 0) return null;

  return (
    <div className="card" style={{ padding: 16, display: 'grid', gap: 12 }}>
      {activeLoans.length > 0 && (
        <div>
          <div style={{ fontWeight: 700, marginBottom: 8, display: 'flex', alignItems: 'center', gap: 6 }}>
            <BookOpen size={16} /> My Borrowed Books
          </div>
          <div style={{ display: 'grid', gap: 6 }}>
            {activeLoans.map((loan) => (
              <div key={loan.id} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, borderBottom: '1px solid #f3f4f6', paddingBottom: 4 }}>
                <span>{loan.item_title}</span>
                <span style={{ color: loan.is_overdue ? '#dc2626' : '#6b7280' }}>Due {loan.due_date}{loan.is_overdue ? ' (Overdue)' : ''}</span>
              </div>
            ))}
          </div>
        </div>
      )}
      {fines.length > 0 && (
        <div>
          <div style={{ fontWeight: 700, marginBottom: 8, display: 'flex', alignItems: 'center', gap: 6 }}>
            <Money size={16} /> Outstanding Library Fines
          </div>
          <div style={{ display: 'grid', gap: 6 }}>
            {fines.map((fine) => (
              <div key={fine.id} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, borderBottom: '1px solid #f3f4f6', paddingBottom: 4 }}>
                <span>{fine.item_title} — {fine.reason}</span>
                <span style={{ color: '#dc2626', fontWeight: 600 }}>GHS {fine.amount.toFixed(2)}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default MyLoansPanel;
